(function () {
  function pad(value) {
    return value < 10 ? '0' + value : String(value);
  }

  function getTargetDate(mode, timerText) {
    var now = new Date();

    switch (mode) {
      case 'day':
        return new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
      case 'week': {
        var daysUntilNextMonday = (8 - now.getDay()) % 7;
        if (daysUntilNextMonday === 0) {
          daysUntilNextMonday = 7;
        }

        var weekTarget = new Date(now.getFullYear(), now.getMonth(), now.getDate() + daysUntilNextMonday);
        weekTarget.setHours(0, 0, 0, 0);
        return weekTarget;
      }
      case 'month':
        return new Date(now.getFullYear(), now.getMonth() + 1, 1);
      case 'date':
      default: {
        var targetDate = new Date(timerText);

        if (!Number.isNaN(targetDate.getTime()) && targetDate > now) {
          return targetDate;
        }

        var fallbackDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
        fallbackDate.setHours(0, 0, 0, 0);
        return fallbackDate;
      }
    }
  }

  function updateCountdown(countdown) {
    var hoursEl = countdown.querySelector('[data-timer-hours]');
    var minutesEl = countdown.querySelector('[data-timer-minutes]');
    var secondsEl = countdown.querySelector('[data-timer-seconds]');

    if (!hoursEl || !minutesEl || !secondsEl) {
      return;
    }

    var targetDate = getTargetDate(countdown.dataset.timerMode, countdown.dataset.timerText);
    var timeDifference = targetDate - new Date();

    if (timeDifference <= 0) {
      hoursEl.textContent = '00';
      minutesEl.textContent = '00';
      secondsEl.textContent = '00';
      return;
    }

    var totalHours = Math.floor(timeDifference / (1000 * 60 * 60));
    var minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

    hoursEl.textContent = pad(totalHours);
    minutesEl.textContent = pad(minutes);
    secondsEl.textContent = pad(seconds);
  }

  function initSection(section) {
    var countdowns = section.querySelectorAll('.et-bundle-announcement__timer');

    countdowns.forEach(function (countdown) {
      if (countdown.dataset.initialized === 'true') {
        return;
      }

      countdown.dataset.initialized = 'true';
      updateCountdown(countdown);

      window.setInterval(function () {
        updateCountdown(countdown);
      }, 1000);
    });
  }

  function initAll() {
    document.querySelectorAll('.et-bundle-announcement').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.classList.contains('et-bundle-announcement')) {
      initSection(event.target);
    }
  });
})();
